import { combineReducers } from "redux";
import oncallDataReducer from "./oncallDataReducer";

export default combineReducers({
    oncallDataReducer
});
